import React from "react"
import "./SampleQuestion.scss"
import { faTrash } from "@fortawesome/pro-light-svg-icons/faTrash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ClassProps } from "../../../utility/common/props"
import cn from "classnames"
import { ComparisonType } from "../../../models/articleCompare"
import { FormCheck } from "react-bootstrap"
import { textDomParser } from "../../../utility/common/textDomParser"

export interface SampleQuestionProps extends ClassProps {
    content: string
    testId: string
    onSelect?: (selected?: boolean) => void
    onDelete?: () => void
    selected?: boolean
    isDeletable?: boolean
    comparisonType?: ComparisonType
    displayCheckBox?: boolean
    id?: string
}

export const testIdPrefix = "sampleQuestion-"

const SampleQuestion: React.FC<SampleQuestionProps> = props => {
    const {
        content,
        onSelect,
        onDelete,
        className,
        isDeletable,
        selected = false,
        comparisonType,
        displayCheckBox = false,
        id,
        testId
    } = props

    const handleDelete = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        e.stopPropagation()
        onDelete && onDelete()
    }

    const parsedText = textDomParser(content)

    return (
        <div
            className={cn("sample-question", selected && "sample-question_selected", className)}
            onClick={() => {
                onSelect && onSelect(selected)
            }}
            data-testid={testIdPrefix + testId}
        >
            {displayCheckBox && onSelect && (
                <FormCheck
                    custom
                    id={`sample-questions-checkbox-${id}`}
                    type="checkbox"
                    checked={selected}
                    className={"sample-question__checkbox"}
                    onClick={e => {
                        e.stopPropagation()
                    }}
                    readOnly
                ></FormCheck>
            )}
            <div className={cn("sample-question__content", `sample-question__${comparisonType}`)}>{parsedText}</div>
            {isDeletable && (
                <div className="sample-question__controls">
                    <div className="sample-question__control">
                        <FontAwesomeIcon icon={faTrash} onClick={handleDelete} size="lg" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default SampleQuestion
